import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';

import { NgxGaugeModule } from 'ngx-gauge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '../shared/shared.module';

import { OperationsComponent } from './operations-dashboard/operations-page.component';
import { SingleValueComponent } from './widgets/single-value/single-value.component';
import { SingleValueModalComponent } from './widgets/single-value/single-value-modal/single-value-modal.component';
import { GaugeValueComponent } from './widgets/gauge-value/gauge-value.component';
import { GaugeValueModalComponent } from './widgets/gauge-value/gauge-value-modal/gauge-value-modal.component';
import { VerticalBarsComponent } from './widgets/vertical-bars/vertical-bars.component';
import { VerticalBarsModalComponent } from './widgets/vertical-bars/vertical-bars-modal/vertical-bars-modal.component';
import { HorizontalBarsComponent } from './widgets/horizontal-bars/horizontal-bars.component';
import { HorizontalBarsModalComponent } from './widgets/horizontal-bars/horizontal-bars-modal/horizontal-bars-modal.component';
import { LineValuesComponent } from './widgets/line-values/line-values.component';
import { LineValuesModalComponent } from './widgets/line-values/line-values-modal/line-values-modal.component';
import { DownloadChartsPdfDialogComponent } from './operations-dashboard/services/download-charts-pdf/download-charts-pdf-dialog/download-charts-pdf-dialog.component';
import { DownloadChartsPdfSnackbarComponent } from './operations-dashboard/services/download-charts-pdf/download-charts-pdf-snackbar/download-charts-pdf-snackbar.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    MatMenuModule,
    NgxGaugeModule,
    MatTooltipModule,
    OverlayModule,
  ],
  declarations: [
    OperationsComponent,
    SingleValueModalComponent,
    SingleValueComponent,
    VerticalBarsComponent,
    VerticalBarsModalComponent,
    HorizontalBarsComponent,
    HorizontalBarsModalComponent,
    GaugeValueComponent,
    GaugeValueModalComponent,
    LineValuesComponent,
    LineValuesModalComponent,
    DownloadChartsPdfDialogComponent,
    DownloadChartsPdfSnackbarComponent,
  ],
  providers: [DecimalPipe],
})
export class OperationsDashboardModule {}
